import { Form } from 'antd';
import { VFC, useEffect } from 'react';
import { FORM_LAYOUT_CONFIG } from 'consts/common';
import { FormItem } from 'components/Form/FormItem';
import { useScrollTopOnMount } from 'hooks/useScrollTopOnMount';
import { useReplaceMeterStore } from 'routes/meter_replacement/useStore';
import { useReplaceMeterStepsStore } from 'routes/meter_replacement/useStepsStore';
import TextArea from 'antd/lib/input/TextArea';
import { FormattedMessage, useIntl } from 'react-intl';
import { TypeDetails } from './components/TypeDetails';
import { DETAILS_FORM_ID } from './constants';
import { DetailsStepForm } from './slice';
import { DetailsStepContent as messages } from './messages';
import { MeterModelDivider } from '../../../../components/Divider/MeterModelDivider';

export const DetailsStepContent: VFC = () => {
  const [form] = Form.useForm<DetailsStepForm>();
  const intl = useIntl();

  const { setNextStep } = useReplaceMeterStepsStore();
  const { internalNote, setDetailsStepValues } = useReplaceMeterStore();

  const handleValuesChange = (changedValues: Partial<DetailsStepForm>, allValues: DetailsStepForm) => {
    // Reset selected circuit_breaker_size value when phases are changed
    if (changedValues?.detail && 'phases' in changedValues.detail) {
      const emptyCircuitBreaker = {
        detail: {
          ...allValues.detail,
          circuit_breaker_size: undefined,
          phases: changedValues.detail.phases,
        },
      };

      // @ts-ignore - Type is correct, but TS can't infer it
      setDetailsStepValues(emptyCircuitBreaker);
      return form.setFieldsValue(emptyCircuitBreaker);
    }

    setDetailsStepValues(allValues);
  };

  const handleSubmit = () => {
    setNextStep();
  };

  useEffect(() => {
    const { detail: initialDetail } = form.getFieldsValue();
    setDetailsStepValues({ detail: initialDetail });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array ensures this runs only once on mount (some fields are updated directly inside FormItem, this sync form state to store)

  useScrollTopOnMount();

  return (
    <Form
      form={form}
      id={DETAILS_FORM_ID}
      layout="horizontal"
      onFinish={handleSubmit}
      onValuesChange={handleValuesChange}
      {...FORM_LAYOUT_CONFIG}
    >
      <MeterModelDivider />

      <TypeDetails />

      <FormItem
        initialValue={internalNote}
        label={<FormattedMessage {...messages.note} />}
        name={'internalNote' satisfies keyof DetailsStepForm}
      >
        <TextArea autoSize={{ minRows: 3, maxRows: 5 }} placeholder={intl.formatMessage(messages.notePlaceholder)} />
      </FormItem>
    </Form>
  );
};
